import React, { useEffect, useState, useMemo } from "react";
import { Table, Spin, Input } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FamilyGroupTable from "./levels/FamilyGroupTable";

import ClientModal from "./modals/ClientModal";
import FolioModal from "./modals/FolioModal";
import SchemeModal from "./modals/SchemeModal";
import TransactionModal from "./modals/TransactionModal";
import { LedgerResponsiveWrapper } from "./LedgerResponsive";  // ✅ mobile responsive wrapper

const API_BASE = "https://kgonline.in/api";
const getArn = () => localStorage.getItem("arn_number");

export default function FamilyLedgerView() {
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  // --- Modal States ---
  const [clientModalOpen, setClientModalOpen] = useState(false);
  const [folioModalOpen, setFolioModalOpen] = useState(false);
  const [schemeModalOpen, setSchemeModalOpen] = useState(false);
  const [txnModalOpen, setTxnModalOpen] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null);

  // --- Handlers ---
  const openClientModal = (record) => {
    setActiveRecord(record);
    setClientModalOpen(true);
  };
  const openFolioModal = (record) => {
    setActiveRecord(record);
    setFolioModalOpen(true);
  };
  const openSchemeModal = (record) => {
    setActiveRecord(record);
    setSchemeModalOpen(true);
  };
  const openTxnModal = (record) => {
    setActiveRecord(record);
    setTxnModalOpen(true);
  };

  useEffect(() => {
    if (!getArn()) return navigate("/login");
    setLoading(true);
    axios
      .get(`${API_BASE}/get_families.php?arn_no=${getArn()}&group=yes`)
      .then((res) => setFamilies(res.data.families || []))
      .catch(() => setFamilies([]))
      .finally(() => setLoading(false));
  }, [navigate]);

  const filteredFamilies = useMemo(() => {
    if (!q) return families;
    const s = q.toLowerCase();
    return families.filter(
      (f) =>
        (f.group_name || "").toLowerCase().includes(s) ||
        (f.master_pan || "").toLowerCase().includes(s)
    );
  }, [families, q]);

  return (
    <div style={{ padding: 16 }}>
      <h1 style={{ marginBottom: 16 }}>Family Ledger</h1>

      <Input
        placeholder="Search family group or PAN"
        value={q}
        allowClear
        onChange={(e) => setQ(e.target.value)}
        style={{ width: 300, marginBottom: 12 }}
      />

      {loading ? (
        <Spin />
      ) : (
        <LedgerResponsiveWrapper>   {/* ✅ now mobile-friendly */}
          <FamilyGroupTable
            data={filteredFamilies}
            onOpenClientModal={openClientModal}
            onOpenFolioModal={openFolioModal}
            onOpenSchemeModal={openSchemeModal}
            onOpenTxnModal={openTxnModal}
          />
        </LedgerResponsiveWrapper>
      )}

      {/* --- Modals Reused from Individual Ledger --- */}
      <ClientModal
        open={clientModalOpen}
        onClose={() => setClientModalOpen(false)}
        record={activeRecord}
      />
      <FolioModal
        open={folioModalOpen}
        onClose={() => setFolioModalOpen(false)}
        record={activeRecord}
      />
      <SchemeModal
        open={schemeModalOpen}
        onClose={() => setSchemeModalOpen(false)}
        record={activeRecord}
      />
      <TransactionModal
        open={txnModalOpen}
        onClose={() => setTxnModalOpen(false)}
        record={activeRecord}
      />
    </div>
  );
}
